import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	background-color: ${color.interface.white};
	display: grid;
	gap: 1rem;
	grid-template-rows: auto auto;
	overflow: hidden;
	border: 1px solid ${color.interface.lightGray2};
`;

export const photo = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> img {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}
`;

export const like = styled.div`
	right: 5px;
	bottom: 5px;
	position: absolute;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	> svg {
		color: ${color.interface.black};
		font-size: 25px;
	}
`;

export const infos = styled.div`
	width: 100%;
	height: 100%;
	gap: 0.5rem;
	display: flex;
	padding: 0px 8px 8px 8px;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
`;

export const title = styled.div`
	> b {
		font-weight: 900;
		text-align: left;
		font-size: 1.2rem;
		color: ${color.interface.blackMofiq};
		font-family: nunito-light;
	}
`;

export const price = styled.p`
	text-align: left;
	font-size: 1.2rem;
	color: ${color.interface.blackMofiq};
	font-weight: 900;
`;
